import React, { useState } from 'react';
import {Button, TextField} from '@mui/material';
import { GiHomeGarage } from 'react-icons/gi';

const ZipCodeInput = ({ zipCode, setZipCode }) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleZipCodeChange = (event) => {
    setZipCode(event.target.value);
  };
  
  const handleZipCodeClick = () => {
    setIsEditing(true);
  };
  
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === 'Escape') {
      setIsEditing(false);
    }
  };

  const handleZipCodeBlur = () => {
    setIsEditing(false);
  };

  return (
      isEditing ? (
        <TextField
          value={zipCode}
          onChange={handleZipCodeChange}
          onKeyDown={handleKeyDown}
          onBlur={handleZipCodeBlur}
          slotProps={{ htmlInput: { maxLength: 5, style: { height: '10px', width: '50px' } } }}
          autoFocus
          variant="outlined"
          size="medium"
          style={{ marginRight: 5, verticalAlign: 'middle' }}
          sx={{
            '& .MuiOutlinedInput-root': {
                'fieldset': {
                  borderWidth: '2px',
                },
                '&:hover fieldset': {
                    borderColor: 'rgb(207, 32, 47)',
                    borderWidth: '2px'
                },
                '&.Mui-focused fieldset': {
                    borderColor: 'rgb(207, 32, 47)',
                    borderWidth: '2px'
                },
            },
        }}
        />
      ) : (
        <Button 
            onClick={handleZipCodeClick}
            sx={{
              color: 'rgb(207, 32, 47)',
              fontWeight: 'bold',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'rgb(207, 32, 47)',
                color: 'white',
                borderRadius: '4px',
              },
            }}
        >
          {zipCode || 'Zip Code'}
          <GiHomeGarage style={{ marginLeft: 5, color: 'inherit', verticalAlign: 'top', fontSize:'28px' }} />
        </Button>
      )
  )
};

export default ZipCodeInput;